import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Col, Form, Input, Modal, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { getResultCheckInActivities } from 'app/entities/progress-log/progress-log.reducer';
import TableComponent from 'app/shared/component/table/table';
import { columns } from './config';
import dayjs from 'dayjs';
import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

type IReportActivitiesResult = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
  idSelected: string;
};

export const ReportActivitiesResult = ({ isOpen, onClose, idSelected }: IReportActivitiesResult) => {
  const dispatch = useAppDispatch();
  const progressLogList = useAppSelector(state => state.progressLog.entities);
  const isLoading = useAppSelector(state => state.progressLog.loading);

  useEffect(() => {
    innitData();
  }, [idSelected]);

  const innitData = () => {
    if (idSelected) {
      dispatch(getResultCheckInActivities(idSelected));
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      width={'1300px'}
      open={isOpen}
      footer={null}
      onCancel={() => {
        handleClose();
      }}
    >
      <div className="view">
        <Title level={3}>Kết quả thực hiện công việc</Title>
        <div className="table">
          <Form layout="vertical">
            <Row>
              <Col md={4}>
                <Form.Item label="Mã công việc">
                  <Input readOnly value={progressLogList?.code} size="large" />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={5}>
                <Form.Item label="Lĩnh vực">
                  <Input readOnly value={progressLogList?.fieldName} size="large" />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={5}>
                <Form.Item label="Dự án">
                  <Input readOnly value={progressLogList?.projectName} size="large" />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={6}>
                <Form.Item label="Mảng công việc">
                  <Input readOnly value={progressLogList?.workTypeName} size="large" />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Form.Item label="Nội dung công việc">
                  <TextArea rows={1} value={progressLogList?.purpose} className="w-100" readOnly size="large" />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={4}>
                <Form.Item label="Ngày bắt đầu">
                  <Input className="w-100" value={dayjs(progressLogList?.startDate).format(APP_LOCAL_DATE_FORMAT)} readOnly size="large" />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={5}>
                <Form.Item label="Thời hạn hoàn thành">
                  <Input className="w-100" value={dayjs(progressLogList?.dueDate).format(APP_LOCAL_DATE_FORMAT)} readOnly size="large" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <TableComponent
            data={progressLogList?.results?.map((x, index) => {
              return {
                key: index + 1,
                ...x,
              };
            })}
            tableLayout="fixed"
            scroll={true}
            noPagination={true}
            isFetching={isLoading}
            columns={columns}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ReportActivitiesResult;
